import PlainDate from '@Domain/PlainDate';

/**
 * True only for a real calendar date in `AAAA-MM-JJ` form. `PlainDate.fromApi` only checks the
 * pattern, not the range of each component: an out-of-range month or day (`2024-13-40`) parses
 * without complaint, so this round-trips through a real `Date` and compares the components back —
 * `Date`'s own constructor rolls an invalid day/month into the next one, which this catches.
 */
const isValidCalendarDateString = (value: string): boolean => {
	const plainDate = PlainDate.fromApi(value);

	if (plainDate === null) {
		return false;
	}

	const calendar = plainDate.toCalendar();

	return (
		calendar.getFullYear() === plainDate.year &&
		calendar.getMonth() === plainDate.month - 1 &&
		calendar.getDate() === plainDate.day
	);
};

export default isValidCalendarDateString;
